export enum PageModelsActions {
  Update = 'UPDATE_PAGE_MODELS',
}

export interface PageModelsType {
  config: any;
  labels: any;
  taxonomy: any;
  ready: boolean;
  esCustomLabels: Record<string, string>;
  esLabels: Record<string, string>;
  httpStatusCode: string;
  language: string;
  langToRedirect: string;
}

export type PageModelsPayloadType = {
  [PageModelsActions.Update]: PageModelsType;
};
